var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 13,
  viewBox: "0 0 15 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m8.067 12.467 6.082-5.994.001-.337L8.067 0s.076 2.728 0 3.836c-2.072-.01-.99.104-1.867.313C3.023 4.907 1.26 6.92.558 8.89c-.315.885-.422 1.787-.516 2.464C-.05 12.018.038 12.9.038 12.9s2.776-3.36 4.393-3.774c2.105-.54 3.636-.369 3.636-.369z"
})));
export default SvgFacebookDesktopShare;